<script setup>
import { computed } from 'vue';
import { useFieldErrors } from '@/composables/ruleEngine/useFieldErrors';

const props = defineProps({
    modelValue: { type: Object, default: () => ({}) },
    labelKey: { type: String, required: true },
    errors: { type: [Array, Object], default: () => ({}) },
});

const emit = defineEmits(['update:modelValue', 'touched']);

const { errorsFor } = useFieldErrors(props);

const checked = computed({
    get: () => (props.modelValue?.must_be_true !== false),
    set: (value) => {
        emit('touched');
        emit('update:modelValue', {
            ...(props.modelValue || {}),
            must_be_true: !!value,
        });
    },
});
</script>

<template>
<StyledCheckbox
    v-model="checked"
    name="must_be_true"
    :label="$t(labelKey)"
    :error-messages="errorsFor('must_be_true')" />
</template>
